import { Component } from "@angular/core"

@Component({
  imports: [],
  standalone: true,
  template: `
    <p>
      util-route-listener works!
    </p>
  `,
  selector: "lib-util-route-listener",
})
export class UtilRouteListenerComponent {
}
